import { AppBar, Box, Toolbar, Typography } from '@mui/material';
import AppMenu from './AppMenu';
import ProfileMenu from './ProfileMenu';

const {
  VITE_BRAND_ICON: BrandIcon,
  VITE_HEADER_LOGO: BrandLogo,
  VITE_BRAND_NAME: BrandName,
  VITE_BRAND_TOOLTIP: BrandTooltip,
  VITE_APP_BASE_URL,
} = import.meta.env;

const companyLogo = import.meta.env.VITE_COMPANY_LOGO || '/icons.svg';

export default function AccessDeniedHeader() {
  return (
    <AppBar style={{ position: 'fixed' }}>
      <Toolbar>
        <a
          className="app_link"
          href={VITE_APP_BASE_URL}>
          <Box
            component="span"
            className="app-icon">
            <img
              alt="App"
              src={companyLogo}
              id="app-logo"
            />
            <Typography
              sx={{ color: '#fff', paddingLeft: '8px' }}
              variant="h5"
              id="app-title">
              Manage
            </Typography>
          </Box>
        </a>

        <Box
          component="span"
          className="center-container brand-icon">
          {BrandIcon && (
            <img
              src={BrandIcon || ''}
              alt={BrandTooltip || ''}
            />
          )}
          {BrandLogo && (
            <img
              src={BrandLogo || ''}
              alt={BrandTooltip || ''}
            />
          )}
          {BrandName || ''}
        </Box>
        <AppMenu />
        <ProfileMenu />
      </Toolbar>
    </AppBar>
  );
}
